'use strict';

var _themeAddresses = require('@shopify/theme-addresses');

require('../../components/forms');

require('./sidebar');

var selectors = {
  newAddressForm: document.querySelector('.js-add-address-form'),
  inputFields: document.querySelectorAll('.js-form-field input'),
  editButtons: document.querySelectorAll('.js-edit-address'),
  cancelEditButtons: document.querySelectorAll('.js-cancel-edit-address'),
  deleteButtons: document.querySelectorAll('.js-delete-address'),
  newAddressButton: document.querySelector('.js-add-address'),
  cancelNewAddressButton: document.querySelector('.js-cancel-new-address')
}; /**
    * Customer Addresses Script
    * ------------------------------------------------------------------------------
    * A file that contains scripts highly couple code to the Customer Addresses
    * template.
    *
    * @namespace customerAddresses
    */

function addButtonListeners() {
  // Edit buttons
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = selectors.editButtons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var button = _step.value;

      clickCallback(button, toggleEditForm);
    }

    // Cancel edit buttons
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = selectors.cancelEditButtons[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _button = _step2.value;

      clickCallback(_button, toggleEditForm);
    }

    // New address button
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  clickCallback(selectors.newAddressButton, toggleNewForm);

  // Cancel new address button
  clickCallback(selectors.cancelNewAddressButton, toggleNewForm);
}

function toggleEditForm(button) {
  var wrapper = button.closest('.js-address-details');
  var form = wrapper.querySelector('.js-edit-address-form');
  var inputs = form.querySelectorAll('.js-form-field input');
  var selects = form.querySelectorAll('select');

  // Account for ADA
  if (form.classList.contains('visually-hidden')) {
    toggleIndex(inputs, '0');
    toggleIndex(selects, '0');
    inputs[0].focus();
  } else {
    toggleIndex(inputs, '-1');
    toggleIndex(selects, '-1');
  }

  form.classList.toggle('visually-hidden');
}

function toggleNewForm() {
  var form = selectors.newAddressForm;
  var inputs = form.querySelectorAll('.js-form-field input');
  var selects = form.querySelectorAll('select');

  // Account for ADA
  if (form.classList.contains('visually-hidden')) {
    toggleIndex(inputs, '0');
    toggleIndex(selects, '0');
    inputs[0].focus();
  } else {
    toggleIndex(inputs, '-1');
    toggleIndex(selects, '-1');
  }

  form.classList.toggle('visually-hidden');
}

// ADA "click" event
function clickCallback(element, callback) {
  element.addEventListener('click', function () {
    callback(element);
  });
  element.addEventListener('keydown', function (event) {
    return event.keyCode === 13 ? callback(element) : false;
  });
}

function toggleIndex(elements, indexValue) {
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = elements[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var element = _step3.value;

      element.setAttribute('tabindex', indexValue);
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }
}

addButtonListeners();